import { styled, rootShouldForwardProp } from "@tino-frontend/coreui";
import ReactMarkdown from "react-markdown";
const MarkdownRoot = styled(ReactMarkdown, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueMarkdown",
  slot: "Root"
})(() => ({}));
export {
  MarkdownRoot
};
//# sourceMappingURL=markdown.styles.js.map
